(function ($) {
    /**
     * Plugin jQuery dsNavLinkGroup – transforme un groupe de liens en accordéon
     * selon le breakpoint fourni.
     *
     * @param {Object} options
     * @param {string} [options.dsCollapseBreakpoint="xl"] - breakpoint
     *        (xs, sm, md, lg, xl)
     */
    $.fn.dsNavLinkGroup = function (options) {
        const defaults = {
            dsCollapseBreakpoint: "xl"
        };

        // Mapping des breakpoints
        const breakpointMap = {
            xs: 0,
            sm: 375,
            md: 768,
            lg: 1024,
            xl: 1280
        };

        // Fonction pour générer un UUID
        function uuid() {
            return 'xxxxyxxx'.replace(/[xy]/g, function (c) {
                let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

        function getBreakpointValue(bp) {
            return breakpointMap[bp] !== undefined ? breakpointMap[bp] : breakpointMap.xl;
        }

        // Mise à jour de la structure
        function updateLayout(state) {
            const collapse = window.innerWidth < state.breakpointPx;

            if (collapse && !state.isCollapsed) {
                state.isCollapsed = true;
                convertToAccordion(state);
            } else if (!collapse && state.isCollapsed) {
                state.isCollapsed = false;
                convertToDesktop(state);
            }
        }

        // Conversion en Accordion (mobile)
        function convertToAccordion(state) {
            const $group = state.group;
            const $header = $group.find(`.${state.classes.header}`).first();
            const $body = $group.find(`.${state.classes.body}`).first();

            // Crée le bouton trigger
            const btnId = `trigger-${state.uuid}`;
            const panelId = `panel-${state.uuid}`;

            const $button = $('<button>', {
                class: state.classes.trigger,
                type: 'button',
                id: btnId,
                'aria-controls': panelId,
                'aria-expanded': 'false',
                'data-toggle': 'collapse',
                'data-target': `#${panelId}`,
                text: state.originalTitle
            });

            // Remplace le texte du header par le bouton
            $header.empty().append($button);

            // Ajoute les classes & attributs Bootstrap au corps
            $body
                .addClass('collapse')
                .attr('id', panelId)
                .attr('aria-labelledby', btnId);

            // Instancie le collapse
            const collapseInst = $body.collapse('hide');
            state.collapseInstance = collapseInst;
        }

        // Convertion à la structure originale (Desktop)
        function convertToDesktop(state) {
            const $group = state.group;
            const $header = $group.find(`.${state.classes.header}`).first();
            const $body = $group.find(`.${state.classes.body}`).first();

            // Restaure le texte du header
            $header.empty().text(state.originalTitle);

            // Nettoie le corps
            $body
                .removeClass('collapse')
                .removeAttr('aria-labelledby');
            const bodyId = $body.attr('id');
            if (bodyId && bodyId.includes(state.uuid)) {
                $body.removeAttr('id');
            }

            // Détruit l'instance collapse si elle existe
            if (state.collapseInstance) {
                $body.collapse('dispose');
                state.collapseInstance = null;
            }
        }

        // Fonction de debounce pour les événements resize
        function debounce(func, wait) {
            let timeout;
            return function () {
                const context = this, args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), wait);
            };
        }

        // Initialisation
        function init() {
            const $group = $(this);
            if ($group.data('dsNavLinkGroupInitialized')) return;

            const settings = $.extend({}, defaults, options);
            const breakpoint = $group.attr('data-ds-collapse-breakpoint') ||
                settings.dsCollapseBreakpoint;
            const breakpointPx = getBreakpointValue(breakpoint);

            const uuidValue = uuid();

            // Classes attendues dans le markup d'origine
            const classes = {
                header: 'm-nav-link-group__header',
                body: 'm-nav-link-group__body',
                trigger: 'm-nav-link-group__trigger'
            };

            // Nav Header
            const groupId = $group.attr('id') || `nav-link-group-${uuidValue}`;
            if (!$group.attr('id')) {
                $group.attr('id', groupId);;
            }

            // header
            const $header = $group.find(`.${classes.header}`).first();

            const state = {
                uuid: uuidValue,
                group: $group,
                breakpoint,
                breakpointPx,
                isCollapsed: null,
                classes,
                collapseInstance: null,
                originalTitle: $header.text()
            };

            // Première mise en page
            updateLayout(state);

            // Resize handler (debounced)
            const debounced = debounce(() => updateLayout(state), 100);
            $(window).on(`resize.dsNavLinkGroup-${uuidValue}`, debounced);

            // API publique
            const api = {
                destroy: function () {
                    if (!state) return;

                    // Retour à la version desktop (si on était en accordion)
                    if (state.isCollapsed) convertToDesktop(state);

                    const groupId = $group.attr('id');
                    if (groupId && groupId.includes(uuidValue)) {
                        $group.removeAttr('id');
                    }

                    // Nettoyage des listeners & data
                    $(window).off(`resize.dsNavLinkGroup-${uuidValue}`);
                    $group.removeData('dsNavLinkGroup');
                    $group.removeData('dsNavLinkGroupInitialized');

                    // Réinitialiser l'état
                    state = null;
                }
            };

            // Stockage de l'instance
            $group.data('dsNavLinkGroup', api);
            $group.data('dsNavLinkGroupInitialized', true);
        }

        // Initialiser le plugin
        return this.each(init);
    };
})(jQuery);